import { Box, Typography } from '@mui/material';
import JourneyNewCardForm from '~/components/JourneyPayment/JourneyNewCardForm';
import JourneyPaymentMethodSelector from '~/components/JourneyPayment/JourneyPaymentMethodSelector';
import { NEW_CARD_OPTION, type JourneyAddedCard } from '~/components/JourneyPayment/types';
import type { CardInput, CardToken } from '~/services/modules/paymentGateway';
import { lookupRenewalZipcode } from '~/services/modules/renewal';
import type { BrazilAddressFields } from '~/utils/brazilAddress';
import { CARD_CHANGE_APP_IDS } from '../cardChangeAppIds';

type Props = {
  /** Endereço do segurado; só completa o `JourneyAddedCard` (o formulário não mostra endereço). */
  billingAddress: Partial<BrazilAddressFields>;
  publicKey: string | null;
  publicKeyLoading?: boolean;
  onCardAdded: (card: JourneyAddedCard) => void;
  tokenize?: (publicKey: string | null | undefined, card: CardInput) => Promise<CardToken>;
};

/**
 * «Escolha a forma de pagamento» da troca de cartão 2026 (Figma 2097:5628). Os cartões salvos ficam ocultos
 * (CORE-988: o link não traz o id do cliente), então só «Novo cartão de crédito» aparece, já aberto. Sem
 * «Endereço de cobrança»: o `PATCH v2/Contracts/{hash}/card` (`UpdateCardRequest`) só recebe o token.
 */
export default function CardChangeFormStep({
  billingAddress,
  publicKey,
  publicKeyLoading = false,
  onCardAdded,
  tokenize
}: Props) {
  return (
    <Box
      data-app-id={CARD_CHANGE_APP_IDS.stepForm}
      sx={{ display: 'flex', flexDirection: 'column', gap: '24px', maxWidth: 708, mx: 'auto', width: '100%' }}
    >
      <Box>
        <Typography component="h1" sx={{ color: 'text.primary' }} variant="h5">
          Escolha a forma de pagamento
        </Typography>
        <Typography sx={(theme) => ({ color: theme.customColors.textPlaceholder })} variant="subtitle1">
          A cobrança é mensal e recorrente no cartão de crédito escolhido.
        </Typography>
      </Box>

      <JourneyPaymentMethodSelector
        appId={CARD_CHANGE_APP_IDS.paymentMethod}
        cards={[]}
        newCardForm={
          <JourneyNewCardForm
            appId={CARD_CHANGE_APP_IDS.newCard}
            defaultBillingAddress={billingAddress}
            lookupZipcode={lookupRenewalZipcode}
            onAdded={onCardAdded}
            publicKey={publicKey}
            publicKeyLoading={publicKeyLoading}
            showBillingAddress={false}
            tokenize={tokenize}
          />
        }
        onSelect={() => undefined}
        savedCardsMode="hidden"
        selectedId={NEW_CARD_OPTION}
      />
    </Box>
  );
}
